import { useState } from 'react'
import useAsyncEffect from 'shared/hooks/use-async-effect'

export enum ApiStatus {
    IDLE,
    FETCHING,
    FETCHED,
}

type KokoProps = {
    term: string
}

type KokoResponse = {
    match_koko_keywords_list: boolean
    is_alarming: boolean
}

export const useKoko = ({ term }: KokoProps) => {
    const [status, setStatus] = useState<ApiStatus>(ApiStatus.IDLE)
    const [data, setData] = useState<KokoResponse>()

    useAsyncEffect(async () => {
        try {
            setStatus(ApiStatus.FETCHING)
            const response = await fetch(`/api/v1/koko/?term=${term}`)
            const data = (await response.json()).result as KokoResponse
            setData(data)
        } catch (err) {
            setData(undefined)
        } finally {
            setStatus(ApiStatus.FETCHED)
        }
    }, [])

    return { status, data }
}
